import { memberPerks } from "@/mocks/homeContent";
import { useReveal } from "@/hooks/useReveal";

export default function MemberPerks() {
  const { ref, visible } = useReveal<HTMLDivElement>(0.1);

  return (
    <section id="perks" className="w-full bg-foreground-950 py-14 md:py-20">
      <div
        ref={ref}
        className={`mx-auto w-full px-4 md:px-8 ${visible ? "reveal is-visible" : "reveal"}`}
      >
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <span className="h-4 w-1 rounded-full bg-accent-400" />
              <span className="text-xs font-medium tracking-[0.18em] text-accent-300">
                MEMBER PRIVILEGE
              </span>
            </div>
            <h2 className="font-heading mt-3 text-2xl font-bold text-background-50 md:text-4xl">
              会员特权
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-background-300 md:text-base">
              黑料福利特权用户可提前看料、看完整版，享受普通用户接触不到的高价值爆料与深度内容。
            </p>
          </div>
          <a
            href="#plans"
            className="flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-400"
          >
            <i className="ri-vip-crown-2-line text-lg" />
            查看会员方案
          </a>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {memberPerks.map((perk) => (
            <div
              key={perk.id}
              className="rounded-lg border border-foreground-800 bg-foreground-900 p-5 md:p-6"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-accent-500/15 text-accent-400">
                <i className={`${perk.icon} text-2xl`} />
              </span>
              <h3 className="font-heading mt-4 text-lg font-semibold text-background-50">
                {perk.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-background-300">{perk.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col gap-4 rounded-lg border border-foreground-800 bg-foreground-900 px-5 py-5 sm:flex-row sm:items-center sm:justify-between md:px-8">
          <div className="flex items-center gap-4">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-timer-flash-line text-2xl" />
            </span>
            <div>
              <p className="font-heading text-base font-semibold text-background-50 md:text-lg">
                平均提前 6 小时看到完整脉络
              </p>
              <p className="mt-1 text-xs text-background-400 md:text-sm">
                热点还在发酵时，整理好的时间线与物料索引已同步给特权用户
              </p>
            </div>
          </div>
          <div className="flex flex-wrap gap-6">
            <div>
              <p className="font-heading text-2xl font-bold text-accent-400">1,280+</p>
              <p className="text-xs text-background-400">专属专题</p>
            </div>
            <div>
              <p className="font-heading text-2xl font-bold text-accent-400">全部</p>
              <p className="text-xs text-background-400">付费资源开放</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}